import { render } from "./Cs2ResultTable.vue?vue&type=template&id=60122115&scoped=true"
import script from "./Cs2ResultTable.vue?vue&type=script&lang=js"
export * from "./Cs2ResultTable.vue?vue&type=script&lang=js"

import "./Cs2ResultTable.vue?vue&type=style&index=0&id=60122115&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60122115"]])

export default __exports__